<template>
  <b-dropdown v-if="_locales.length >= 2">
    <div slot="trigger" slot-scope="{ active }" class="language">
      <div class="language-flag">
        <div class="flag-circle">
          <img :src="_flags[_locale]">
        </div>
      </div>
      <span>
        {{ _locale.toUpperCase() }}
      </span>
      <b-icon size="is-small" :icon="active ? 'chevron-up' : 'chevron-down'" class="ml-2" />
    </div>
    <b-dropdown-item v-for="lang in filtredLocales" :key="lang" has-link>
      <a @click.prevent="switchLanguage(lang)">
        <div class="columns is-mobile is-vcentered">
          <div class="column is-narrow" style="padding-right: 0;">
            <img width="30" :src="_flags[lang]">
          </div>
          <div class="column">
            {{ lang.toUpperCase() }}
          </div>
        </div>
      </a>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import pl from '~/marketplace-front-core/static/icons/flags/pl.svg'
import de from '~/marketplace-front-core/static/icons/flags/de.svg'
import en from '~/marketplace-front-core/static/icons/flags/en.svg'
import fr from '~/marketplace-front-core/static/icons/flags/fr.svg'
import es from '~/marketplace-front-core/static/icons/flags/es.svg'
import it from '~/marketplace-front-core/static/icons/flags/it.svg'
import nl from '~/marketplace-front-core/static/icons/flags/nl.svg'

export default {
  props: {
    target: {
      type: String,
      default: 'navigation-menu'
    },
    ticketLang: {
      type: String,
      default: 'de'
    }
  },
  data () {
    return {
      flag: {
        pl,
        de,
        en,
        fr,
        es,
        it,
        nl
      }
    }
  },
  computed: {
    locales () {
      return process.env.langs.split('|')
    },
    locale () {
      return this.$store.state.i18n.locale
    },
    hiddenLangs () {
      return process.env.hiddenLangs ? process.env.hiddenLangs.split('|') : []
    },
    filteredLocales () {
      return this.locales.filter(x => !this.hiddenLangs.includes(x))
    }
  },
  methods: {
    translatedLocale (lang) {
      switch (lang) {
        case 'en':
          return 'English'
        case 'de':
          return 'Deutsch'
        case 'fr':
          return 'Français'
        case 'es':
          return 'Español'
        case 'it':
          return 'Italiano'
        case 'nl':
          return 'Nederlands'
        case 'pl':
          return 'Polski'
        default:
          return 'Undefined'
      }
    },
    switchLanguage (lang) {
      this.$router.push(this.switchLocalePath(lang))
    },
    switchTicketLanguage (lang) {
      this.$emit('switchTicketLanguage', lang)
    }
  }
}
</script>

<style lang="scss" scoped>
.language {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: 1rem;
  cursor: pointer;
  &.target-messenger {
    gap: 4px;
    margin: 0;
    font-size: 14px;
    .language-flag {
      width: 24px;
      height: 24px;
      border: 1px solid #e4e4e4;
      .flag-circle {
        width: 14px;
        height: 14px;
      }
    }
  }
  .language-flag {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    // border: 1.5px solid #E4E4E4;
    border: none;
    border-radius: 50%;
    .flag-circle {
      width: 24px;
      height: 24px;
      position: relative;
      overflow: hidden;
      border-radius: 50%;
      img {
        display: inline;
        width: auto;
        height: 100%;
      }
    }
  }
}
.language-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  font-size: 14px;
  &:hover {
    background-color: #F7F7F7;
    cursor: pointer;
  }
  img {
    display: block;
    width: 20px;
    height: 20px;
  }
}
.dropdown.target-messenger {
  :deep(.dropdown-menu) {
    left: 0px !important;
  }
}
:deep(.dropdown-menu) {
  left: 8px;
}
</style>
